import { useState } from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebaseConfig";
import "../../styles/auth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const onReset = async (e) => {
    e.preventDefault();
    setError("");
    setOk("");
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setOk("Listo. Te enviamos un correo para restablecer tu contraseña.");
    } catch (err) {
      const msg =
        err?.code === "auth/invalid-email" ? "Correo inválido." :
        err?.code === "auth/user-not-found" ? "No existe una cuenta con ese correo." :
        "No se pudo enviar el correo. Intenta de nuevo.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authWrap">
      <div className="authCard">
        <div className="brandRow">
          <div className="brandLogo">{/* logo */}</div>
          <div>
            <h1 className="brandTitle">Recuperar contraseña</h1>
            <p className="brandSub">Te enviaremos un correo</p>
          </div>
        </div>

        <form onSubmit={onReset}>
          <div className="field">
            <label className="label">Correo</label>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              required
            />
          </div>

          {error ? <div className="errorBox">{error}</div> : null}
          {ok ? <div className="okBox">{ok}</div> : null}

          <button className="primaryBtn" disabled={loading}>
            {loading ? "Enviando..." : "Enviar correo"}
          </button>

          <div className="rowBetween">
            <Link className="linkBtn" to="/login">Volver al login</Link>
            <Link className="linkBtn" to="/signup">Crear cuenta</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
